import { heroHotTopics, tickerItems } from "../../../mocks/hotNews";

interface HeroProps {
  onSearch: (query: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const q = (fd.get("keyword") as string)?.trim() || "";
    onSearch(q);
  };

  return (
    <section id="home" className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20documentary%20scene%20of%20a%20crowd%20of%20people%20watching%20a%20glowing%20city%20night%20screen%20with%20golden%20city%20lights%20and%20spotlight%20beams%2C%20spectator%20atmosphere%2C%20first%20row%20audience%20feeling%2C%20amber%20orange%20and%20cream%20tones%2C%20rich%20texture%2C%20editorial%20photography&width=1800&height=1100&seq=hero-main-2026&orientation=landscape"
        alt="看料门吃瓜围观现场直击前排视角"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-transparent"></div>

      <div className="relative mx-auto flex min-h-[680px] w-full max-w-[1320px] flex-col justify-center px-4 pt-28 pb-20 md:px-6">
        <div className="rise-in max-w-2xl">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/20 px-3 py-1.5 text-xs font-medium text-accent-200">
            <span className="live-dot h-2 w-2 rounded-full bg-accent-500"></span>
            正在直播热议 · 前排围观中
          </div>
          <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            吃瓜围观，<span className="text-primary-400">现场直击</span>
            <br />
            第一时间站上话题风向
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-200 md:text-lg">
            看料门以前排围观群众的视角，实时更新热议话题、高光名场面与讨论风向，热门动态与评论潮流，一秒都不错过。
          </p>

          <form onSubmit={submitSearch} className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row">
            <label className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
              <input
                type="text"
                name="keyword"
                autoComplete="off"
                placeholder="搜一搜你想前排围观的话题"
                className="w-full rounded-full border border-background-200 bg-background-50/95 py-3.5 pl-12 pr-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-300/40"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
            >
              开始围观
            </button>
          </form>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4">
          {heroHotTopics.map((t) => (
            <a
              key={t.id}
              href="#feed"
              className="group flex flex-col gap-2 rounded-2xl border border-background-100/15 bg-background-50/10 p-4 backdrop-blur-sm transition-colors hover:bg-primary-500/20"
            >
              <span className="flex items-center justify-between">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-500 text-xs font-bold text-background-50">
                  0{t.id}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-400">
                  <i className="ri-arrow-up-line"></i> {t.up}
                </span>
              </span>
              <span className="text-sm text-background-50 group-hover:text-accent-200">{t.text}</span>
              <span className="text-xs text-foreground-300">{t.heat} 热度</span>
            </a>
          ))}
        </div>
      </div>

      <div className="relative border-t border-background-100/15 bg-foreground-950/80">
        <div className="mx-auto flex w-full max-w-[1320px] items-center gap-3 px-4 py-3 md:px-6">
          <span className="flex shrink-0 items-center gap-2 text-xs font-semibold text-primary-400">
            <i className="ri-fire-fill text-base text-accent-500"></i>
            滚动热讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max gap-10 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={`${t.id}-${i}`} className="flex items-center gap-2 text-sm text-foreground-200">
                  <i className="ri-circle-fill text-[6px] text-accent-500"></i>
                  {t.text}
                  <span className="ml-1 rounded-md bg-secondary-500/20 px-1.5 py-0.5 text-[11px] text-secondary-200">{t.heat}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}